﻿$.fn.dxCtrlSelectModele = function custom_dxCtrlSelectModele(option) {
    if (option == "instance") {
        return this.instance;
    }
    else {
        this.addClass("dx-dxctrlselectmodele dx-ctrl");
        this.createInstance(new cdxCtrlSelectModele(this, option));
    }
    return this;
}

window.cdxCtrlSelectModele = function (container, option) {
    var Me = this;

    this.option = function (name, value) {
        if (typeof value == 'undefined') {
            return option[name];
        }
        else {
            option[name] = value;
        }
    }

    //=== type
    //email
    //courrier
    //facture

    var $DivContent = null
    var popup = null
    function mConstruit() {
        container.empty()

        popup = $("<div/>").appendTo("body").dxCtrlPopupBase({
            fullScreen: true,
            showTitle: false,
            contentTemplate: function (contentElement) {
                contentElement.css("position", "relative")
                dxBtClose = $("<div style='position:absolute;z-index:101;top:2px;right:5px'/>").appendTo(contentElement).dxCtrlButton({
                    icon: 'fas fa-times',
                    width: HeightButton,
                    height: HeightButton,
                    onClick: function (e) {
                        popup.hide()
                    }
                }).dxCtrlButton("instance");

                var ds = []
                if (!option.disableConcepteurSignature) {
                    ds.push({ id: 0, text: "Modèle de base", tooltip: "Modèle avec différentes mise en page basique" })
                    ds.push({ id: 1, text: "Modèle d'inspiration", tooltip: "Modèle entièrement conceptualisé" })
                }

                if (option.bddCtrl.objCptCli.objetMetier.hasBox()) {
                    ds.push({ id: 2, text: "Vos modèles", tooltip: "Tous les modèles de la box dans votre espace personnel" })
                    ds.push({ id: 3, text: "Modèles partagés", tooltip: "Tous les modèles de la box dans l'espace partagé avec tous les utilisateurs" })
                }
                if (!option.disableDocEnvoiBrouillon) {
                    ds = ds.concat([
                        { id: 4, text: "Vos documents envoyés", tooltip: "Vos documents envoyés dans votre base de données" },
                        { id: 5, text: "Vos documents brouillons", tooltip: "Vos documents brouillons dans votre base de données" }])
                }
                if (option.bddCtrl.objCptCli.objetMetier.hasBox()) {
                    ds.push({ id: 6, text: "Box de fichier", tooltip: "Accédez à la box de fichier" })
                }

                if (typeof option.bddCtrl.utiCourantParaJson["select_modele_" + option.type] == 'undefined') option.bddCtrl.utiCourantParaJson["select_modele_" + option.type] = {}
                if (typeof option.bddCtrl.utiCourantParaJson["select_modele_" + option.type].selectedId == 'undefined') option.bddCtrl.utiCourantParaJson["select_modele_" + option.type].selectedId = ds[0].id

                var selectedItem = ds.filter(function (item) { return item.id == option.bddCtrl.utiCourantParaJson["select_modele_" + option.type].selectedId })[0]
                if (typeof selectedItem == 'undefined') selectedItem = ds[0]

                var dxTabs = $("<div style='position:absolute;top:0;left:0;'/>").appendTo(contentElement).dxTabs({
                    dataSource: ds,
                    selectedItem: selectedItem,
                    orientation: "vertical",
                    itemTemplate: function (itemData, itemIndex, itemElement) {
                        itemElement.parent().css({
                            "text-align": "left",
                            "display": "inline"
                        })
                        if (typeof itemData.tooltip != 'undefined') itemElement.attr("title", itemData.tooltip)
                        return "item"
                    },
                    onItemClick: function (e) {
                        switch (e.itemData.id) {
                            case 0: //modèle de base
                                mRempliModeleServer("gettemplatebase")
                                break;
                            case 1: //modèle d'inspiration
                                mRempliModeleServer("gettemplateinspiration")
                                break;
                            case 2: //modèle box perso
                                mRempliModeleServer("getmodeleonboxperso", true)
                                break;
                            case 3: //modèle box partage
                                mRempliModeleServer("getmodeleonboxpartage", true)
                                break;
                            case 4:
                                mRempliEnvoyes()
                                break;
                            case 5:
                                mRempliBrouillon()
                                break;
                            case 6:
                                mRempliBox()
                                break;
                        }
                        option.bddCtrl.utiCourantParaJson["select_modele_" + option.type].selectedId = e.itemData.id
                        option.bddCtrl.mSaveParaJsonUtilisateur()
                    }
                }).dxTabs("instance")
                $DivContent = $("<div style='position:absolute;top:0;left:" + dxTabs.element().innerWidth() + "px;width:calc(100% - " + dxTabs.element().innerWidth() + "px);height:100%;padding:25px;'/>").appendTo(contentElement)

                dxTabs.option("onItemClick")({ itemData: selectedItem })
                //mRempliModeleServer("gettemplatebase")
            },
            onShown: function (e) {
            },
            onHiding: function (e) {
            }
        }).dxCtrlPopupBase("instance")
        popup.show()

    }

    function mRempliModeleServer(command, allowDelete) {
        $DivContent.empty()
        var dxScroll = $("<div/>").appendTo($DivContent).dxScrollView({}).dxScrollView("instance")
        if (command == "gettemplatebase" && (option.type == "email" || option.type == "formulaire") && !option.disableConcepteurSignature) {
            //rajout concepteur vide
            $("<div/>").appendTo(dxScroll.content()).dxCtrlSelectModelebt({
                bddCtrl: option.bddCtrl,
                nom: "Concepteur vide",
                icon: "fas fa-wand-magic-sparkles",
                onClick: function () {
                    option.onSelectConcepteurVide()
                    popup.hide()
                }
            })
        }
        if (command == "gettemplatebase" && option.type != "formulaire") {
            //rajout editeur
            $("<div/>").appendTo(dxScroll.content()).dxCtrlSelectModelebt({
                bddCtrl: option.bddCtrl,
                nom: ((option.type == "email") ? "Mode éditeur" : "Modèle vide"),
                icon: "fas fa-paragraph",
                onClick: function () {
                    option.onSelectEditeur()
                    popup.hide()
                }
            })

        }
        var $DivRest = $("<div style='min-height:100px;'/>").appendTo(dxScroll.content())
        var jauge = $("<div/>").appendTo($DivRest).dxCtrlJauge({}).dxCtrlJauge("instance")
        jauge.mShow()
        option.bddCtrl.mAjaxCall({ command: command, type: option.type }, function (data) {
            if (typeof data.email_template == 'undefined') data.email_template = []
            if (command != "gettemplatebase" && data.email_template.length == 0) {
                $DivContent.empty()
                $("<div style='width:100%;height:100%;display:flex;align-items:center;justify-content:center;opacity:0.5;font-size:160%;'>Aucun modèle</div>").appendTo($DivContent)
            } else {
                if (command == "gettemplatebase" && !option.disableConcepteurSignature) {
                    //on rajoute les signatures
                    var lstDel = []
                    data.email_template.forEach(function (emailTemplate, idx) {
                        if (emailTemplate.nom.startsWith("signature_")) {
                            $DivRest.before($("<div/>").dxCtrlSelectModelebt({
                                bddCtrl: option.bddCtrl,
                                nom: emailTemplate.nom.substring("signature_".length),
                                //src: emailTemplate.urlhtml,
                                index: idx,
                                pathNomFichier: emailTemplate.path_nom_fichier,
                                type: option.type,
                                allowDelete: allowDelete,
                                onClick: function () {
                                    option.onSelectFile(emailTemplate.path_nom_fichier)
                                    popup.hide()
                                }
                            }))
                            lstDel.push(emailTemplate)
                        }
                    })
                    lstDel.forEach(function (emailTemplate, idx) {
                        data.email_template.splice(data.email_template.indexOf(emailTemplate), 1)
                    })
                }
                var lstGrp = []
                if (command == "gettemplatebase" || command == "gettemplateinspiration") {
                    data.email_template.forEach(function (emailTemplate, idx) {
                        var grp = emailTemplate.path_nom_fichier.split("\\")[emailTemplate.path_nom_fichier.split("\\").length - 2]
                        if (!lstGrp.contains(grp)) lstGrp.push(grp)
                    })
                }

                if (lstGrp.length > 0) {
                    lstGrp.forEach(function (nomGrp) {
                        $("<div style='width:100%;font-size:300%;font-variant:small-caps;padding-left:10px;background-color:" + theme.backgroundcolorTooltip + ";' class='dx-theme-accent-as-text-color'/>").appendTo($DivRest).text(nomGrp.split("_")[1])
                        mRempliGroup(nomGrp)
                    })
                } else {
                    mRempliGroup("")
                }

                function mRempliGroup(nomGroup) {
                    data.email_template.forEach(function (emailTemplate, idx) {
                        if (nomGroup.length == 0 || emailTemplate.path_nom_fichier.contains("\\" + nomGroup + "\\")) {
                            $("<div/>").appendTo($DivRest).dxCtrlSelectModelebt({
                                bddCtrl: option.bddCtrl,
                                nom: emailTemplate.nom,
                                //src: emailTemplate.urlhtml,
                                index: idx,
                                pathNomFichier: emailTemplate.path_nom_fichier,
                                type: option.type,
                                allowDelete: allowDelete,
                                onClick: function () {
                                    option.onSelectFile(emailTemplate.path_nom_fichier)
                                    popup.hide()
                                }
                            })
                        }
                    })
                }

            }
            jauge.mHide()
        })
    }

    function mRempliBrouillon() {
        $DivContent.empty()
        var opt = {
            bddCtrl: option.bddCtrl,
            context_grid: option.type + "_envoi_brouillon_modele",
            allowCheck: false,
            showBtNew: false,
            onHoverDataGrid: function (container, dataGrid) {
                container.empty()
                container.css({
                    "display": "flex",
                    "align-items": "center",
                    "justify-content": "center"
                })
                $("<div/>").appendTo(container).dxCtrlButton({
                    text: "Choisir",
                    onClick: function (e) {
                        option.onSelectData(dataGrid)
                        popup.hide()
                    }
                })
            },
            onClickDataGrid: function (container, dataGrid) {

            }
        }
        switch (option.type) {
            case "email":
                opt.lstIdTypeClassement = [7]
                $("<div/>").appendTo($DivContent).dxCtrlGridEmailEnvoi(opt)
                break;
            case "courrier":
                opt.lstIdTypeClassement = [7]
                $("<div/>").appendTo($DivContent).dxCtrlGridCourrierEnvoi(opt)
                break;
            case "doccpt":
                var lstConditionBase = []
                opt.isBrouillon = true
                opt.grp = "dcr"
                opt.context_grid = "groddoccpt_devis_select"
                lstConditionBase.push({ nom_champ: "id_statut_com", ope: "=", valeur: [{ value: "1" }] })
                opt.lstLstConditionBase = [lstConditionBase]
                $("<div/>").appendTo($DivContent).dxCtrlGridDocCpt(opt)
                break;
        }
    }

    function mRempliEnvoyes() {
        $DivContent.empty()
        var opt = {
            bddCtrl: option.bddCtrl,
            context_grid: option.type + "_envoi_modele",
            lstIdTypeClassement: [7],
            allowCheck: false,
            showBtNew: false,
            onHoverDataGrid: function (container, dataGrid) {
                container.empty()
                container.css({
                    "display": "flex",
                    "align-items": "center",
                    "justify-content": "center"
                })
                $("<div/>").appendTo(container).dxCtrlButton({
                    text: "Choisir",
                    onClick: function (e) {
                        option.onSelectData(dataGrid)
                        popup.hide()
                    }
                })
            },
            onClickDataGrid: function (container, dataGrid) {

            }
        }
        switch (option.type) {
            case "email":
                opt.lstIdTypeClassement = [10]
                $("<div/>").appendTo($DivContent).dxCtrlGridEmailEnvoi(opt)
                break;
            case "courrier":
                opt.lstIdTypeClassement = [10]
                $("<div/>").appendTo($DivContent).dxCtrlGridCourrierEnvoi(opt)
                break;
            case "doccpt":
                var lstConditionBase = []
                opt.isBrouillon = true
                opt.grp = "dcr"
                opt.context_grid = "groddoccpt_cmd_select"
                lstConditionBase.push({ nom_champ: "id_statut_com", ope: "=", valeur: [{ value: "2" }] })
                opt.lstLstConditionBase = [lstConditionBase]
                $("<div/>").appendTo($DivContent).dxCtrlGridDocCpt(opt)
                break;
        }
    }

    function mRempliBox() {
        $DivContent.empty()
        dxCtrlPage = $("<div style='width:100%;height:100%;'/>").appendTo($DivContent).dxCtrlPageFileManager({
            bddCtrl: option.bddCtrl,
            context_grid: "popup_enregistrersousrepertoire",
            allowCheck: false,
            allowCorbeille: false,
            extension: ((option.type == "email") ? ".emlz" : ((option.type == "courrier") ? ".docz" : ((option.type == "email") ? ".dcptz" : ""))),
            allowOpenFile: false,
            mode_selection: true,
            selectedDirectory: option.selectedDirectory,
            onClickFichier: function (data) {
                if (data == null) {
                    //dxCtrlTextBoxNom.option("value", "")
                } else {
                    option.onSelectFile(data.id)
                    popup.hide()
                    //var idFichier = data.id
                    //var obj = option.bddCtrl.getObjet({ id_fichier: idFichier })
                    //dxCtrlTextBoxNom.option("value", obj.mGetNomWithoutExtension())
                }
            }
        }).dxCtrlPageFileManager("instance")
    }

    this.element = function () { return container }

    mConstruit();
}